import { BaseInputRules } from './BaseInputRules';
import { BaseKeymap } from './BaseKeymap';
import { BaseSchema } from './BaseSchema';
import { BaseStyles } from './BaseStyles';
export * from './BaseSchema';
export * from './BaseStyles';
export * from './BaseKeymap';
export * from './BaseInputRules';
export const BasePreset = (builder, opts) => {
    var _a;
    builder
        .use(BaseSchema, (_a = opts.baseSchema) !== null && _a !== void 0 ? _a : {})
        .use(BaseKeymap)
        .use(BaseInputRules)
        .use(BaseStyles);
};
